export interface JwtPayload {
  exp: number;
  username?: string;
  sub?: string;
  must_change_password?: boolean;
}

class JwtService {
  parse(token: string): JwtPayload | null {
    try {
      const parts = token.split(".");
      if (parts.length !== 3) return null;

      const base64Url = parts[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join("")
      );
      return JSON.parse(jsonPayload);
    } catch {
      return null;
    }
  }

  getUsername(token: string): string | null {
    const payload = this.parse(token);
    if (!payload) return null;
    return payload.username || payload.sub || null;
  }

  getMustChangePassword(token: string): boolean {
    const payload = this.parse(token);
    return !!payload?.must_change_password;
  }

  isExpired(token: string, thresholdSeconds = 0): boolean {
    const payload = this.parse(token);
    if (!payload?.exp) return true;
    const now = Math.floor(Date.now() / 1000);
    return payload.exp - thresholdSeconds <= now;
  }
}

export const jwtService = new JwtService();
